import * as React from 'react';

import {StackView} from './Stack.styles';
import {useStack} from './hooks';

import type {StackProps} from './_types';

/**
 * # Stack
 *
 * `Stack` components give developers a declarative way to make stacked sets of elements with theme-aware spacing and alignment.
 *
 * ## Usage
 *
 * ```jsx
 * import { Stack } from "@packages/systems/spring";
 * import {SomeComponent} from '../SomeComponent';
 *
 * const Example = () => {
 *   return (
 *     <Stack direction="column">
 *       <SomeComponent>First</SomeComponent>
 *       <SomeComponent>Second</SomeComponent>
 *       <SomeComponent>Third</SomeComponent>
 *     </Stack>
 *   );
 * };
 * ```
 *
 * @component
 */
export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({children, ...props}, ref) => {
    const stackProps = useStack(props);

    return (
      <StackView ref={ref} {...stackProps}>
        {children}
      </StackView>
    );
  }
);

Stack.displayName = 'Stack';
Stack.toString = StackView.toString;

export default Stack;
